import React from "react";

const getResourceName = (resource) => {
    if (!resource) {
        return "Не назначен";
    }

    const resourceName =
        resource.number ??
        resource.fullName ??
        resource.shortName ??
        resource.user?.fullName ??
        [resource.user?.lastName, resource.user?.firstName, resource.user?.patronymic].filter(Boolean).join(" ");

    return resourceName || "Не назначен";
};

const getResourceId = (resource) => resource?.id ?? resource?.carId ?? resource?.trailerId;

const excludeSelectedItem = (items, selectedItemId) =>
    items.filter((itemId) => itemId && itemId !== selectedItemId);

const isCurrentResource = (resource, actualResource) => {
    const resourceId = getResourceId(resource);
    return Boolean(resourceId && resourceId === getResourceId(actualResource));
};

const Resource = ({ iconCname, title, resource, isCurrent }) => (
    <div className="bid-item-change-form__resource">
        <div className="bid-item-change-form__resource-icon">
            <i className={iconCname} />
        </div>
        <div className="bid-item-change-form__resource-data">
            <strong>{title}</strong>
            <div className="bid-item-change-form__resource-value">{getResourceName(resource)}</div>
            {isCurrent && <small className="text-muted">Сейчас в заявке</small>}
        </div>
    </div>
);

const ReplacementRow = ({ resource, select, iconCname, title, isCurrent }) => (
    <div className="bid-item-change-form__replacement-row">
        <Resource iconCname={iconCname} title={title} resource={resource} isCurrent={isCurrent} />
        <div className="bid-item-change-form__replacement-direction">
            <span>Заменить на</span>
            <i className="icon-uEA93-arrow-left bid-item-change-form__replacement-arrow" />
        </div>
        <div className="bid-item-change-form__replacement-select">{select}</div>
    </div>
);

const ReplacementForm = ({
    currentCar,
    currentDriver,
    currentSecondaryDriver,
    currentTrailer,
    actualCurrentCar,
    actualCurrentDriver,
    actualCurrentSecondaryDriver,
    actualCurrentTrailer,
    showSecondaryDriver,
    onShowSecondaryDriver,
    renderSelect,
    renderCheckbox,
    config,
    excludedDriverIds,
    selectedCarId,
    selectedDriverId,
    selectedSecondaryDriverId,
    selectedTrailerId,
    shouldClearSecondaryDriver,
}) => {
    const hasSecondaryDriver = Boolean(currentSecondaryDriver);
    const primaryDriverTitle = hasSecondaryDriver ? "Основной водитель" : "Водитель";
    const secondaryDriverExcludeItems = excludeSelectedItem(
        [...excludedDriverIds, selectedDriverId],
        selectedSecondaryDriverId,
    );
    const primaryDriverExcludeItems = excludeSelectedItem(
        [...excludedDriverIds, selectedSecondaryDriverId],
        selectedDriverId,
    );

    return (
        <>
            <div className="bid-item-change-form__section-title">1. Что нужно заменить?</div>
            <div className="bid-item-change-form__hint">
                <i className="icon-uEA19-info" />
                <span>Заполните только те поля, где нужно заменить. Остальное оставьте без изменений</span>
            </div>
            <div className="bid-item-change-form__replacements">
                <ReplacementRow
                    iconCname="icon-uEA17-truck"
                    title="Машина"
                    resource={currentCar}
                    isCurrent={isCurrentResource(currentCar, actualCurrentCar)}
                    select={renderSelect({
                        ...config.shiftCarId,
                        label: "Новая машина",
                        excludeItems: excludeSelectedItem([getResourceId(currentCar)], selectedCarId),
                    })}
                />
                <ReplacementRow
                    iconCname="icon-uEA02-avatar"
                    title={primaryDriverTitle}
                    resource={currentDriver}
                    isCurrent={isCurrentResource(currentDriver, actualCurrentDriver)}
                    select={renderSelect({
                        ...config.shiftDriverId,
                        label: "Новый водитель",
                        excludeItems: primaryDriverExcludeItems,
                    })}
                />
                {hasSecondaryDriver || showSecondaryDriver ? (
                    <ReplacementRow
                        iconCname="icon-uEA02-avatar"
                        title="Второй водитель"
                        resource={currentSecondaryDriver}
                        isCurrent={isCurrentResource(currentSecondaryDriver, actualCurrentSecondaryDriver)}
                        select={
                            <>
                                {!shouldClearSecondaryDriver &&
                                    renderSelect({
                                        ...config.shiftSecondaryDriverId,
                                        label: "Второй водитель",
                                        excludeItems: secondaryDriverExcludeItems,
                                    })}
                                {hasSecondaryDriver &&
                                    renderCheckbox({
                                        ...config.shouldClearSecondaryDriver,
                                        bWrapper: "bid-item-change-form__clear-secondary-driver",
                                        labelWrapper: "bid-item-change-form__clear-secondary-driver-label",
                                        fieldWrapper: "bid-item-change-form__clear-secondary-driver-field",
                                        fieldBeforeLabel: true,
                                    })}
                            </>
                        }
                    />
                ) : (
                    <div className="bid-item-change-form__secondary-driver-row">
                        <div className="bid-item-change-form__secondary-driver-link">
                            <span className="link" onClick={onShowSecondaryDriver}>
                                Добавить второго водителя
                            </span>
                        </div>
                    </div>
                )}
                <ReplacementRow
                    iconCname="icon-uEA30-trailer"
                    title="Прицеп"
                    resource={currentTrailer}
                    isCurrent={isCurrentResource(currentTrailer, actualCurrentTrailer)}
                    select={renderSelect({
                        ...config.shiftTrailerId,
                        label: "Новый прицеп",
                        excludeItems: excludeSelectedItem([getResourceId(currentTrailer)], selectedTrailerId),
                    })}
                />
            </div>
        </>
    );
};

export default ReplacementForm;
